// main.js
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import { withTheme } from 'styled-components';
import styled from 'styled-components';

const Logo = styled.span`
    display: inline-block;
    position: relative;
    img {
        object-fit: contain;
        opacity: ${props => (props.theme.teamLogo === 'transparent' ? 0 : 1)};
    }
`;

class TeamLogo extends React.Component {
    static defaultProps = {
        size: 'medium',
        jerseys: false,
        displayTypes: ['none', 'logo', 'jersey', 'svg'],
        theme: {
            teamLogo: 'logo',
        },
    };

    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
        teamLogoSettings: PropTypes.object,
    };

    getDisplay() {
        if (this.props.jerseys) {
            return 'jersey';
        }

        const { tournamentId } = this.props;

        //If we do not have players images on CDN, show jersey
        if (tournamentId && !RCore.hasCDNClubLogos(tournamentId)) return 'jersey';

        return this.props.display || this.context.teamLogoSettings.display || 'none';
    }

    getTeamLogoSrc(teamId, size) {
        const { teamLogo } = this.props.theme;

        switch (teamLogo) {
            case 'jersey':
                return this.showClubsJerseys(teamId);
            case 'logo':
                return this.showTeamLogo(teamId, size);
            case 'empty':
                return this.showTeamLogo(teamId, size);
            case 'transparent':
                return this.showTeamLogo(teamId, size);
            case '3d_jersey':
                return `https://s3-eu-west-1.amazonaws.com/sport.images/wdp/shirts/ic_shirt_${teamId}.svg`;
            // return `https://dxugi372p6nmc.cloudfront.net/wdp/current/shirts/ic_shirt_${teamId}.svg`;
            default:
                return this.showClubsJerseys(teamId);
        }
    }

    showTeamLogo = (teamId, size) => {
        const sizeFolder = '256x256';
        return `https://dxugi372p6nmc.cloudfront.net/wdp/current/${sizeFolder}/${teamId}/teamlogo.png`;
    };

    showClubsJerseys = teamId => {
        const width = 120;
        const height = 120;
        return `https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_shirts_${teamId}.png&width-px=${width}&height-px=${height}&defurl=https://rips.tjekscores.dk/rips/rips.ngx/?url=http://src.releaze.dk/public/soccer-app/assets/shirt_away_def.png`;
    };

    showTeamSVGLogo = teamId => {
        return `https://dxugi372p6nmc.cloudfront.net/wdp/teams/svg/${teamId}.svg`;
    };

    render() {
        const {
            teamId,
            name,
            width,
            height,
            theme = {},
            fontSize,
            style = {},
            teamShortName,
            className,
            lineHeight,
            ...rest
        } = this.props;

        if (!teamId || theme.teamLogo === 'empty') return <span />;
        if (theme.teamLogo === 'short_name')
            return (
                <span
                    className={`${className} wdp-team-logo-name`}
                    style={{
                        lineHeight: (lineHeight || height || width || 40) + 'px',
                        fontSize: (fontSize || (height || width || 40) * 0.7) + 'px',
                        fontWeight: 'bold',
                        position: 'relative',
                        ...style,
                    }}
                >
                    {teamShortName}
                </span>
            );

        const stylesString = RCore.stylesObjectToString(style);

        //     <img
        //     style={this.props.style}
        //     width={width}
        //     height={height}
        //     className="wdp-team-logo"
        //     src={this.getTeamLogoSrc(teamId)}

        // />
        return (
            <Logo
                className={className}
                dangerouslySetInnerHTML={{
                    __html: `<img style="${stylesString}" width="${width || 'auto'}"
                    class="wdp-team-logo"
                    height="${height ||
                        'auto'}" onerror="this.onerror=null;this.src = 'https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_shirt_unknown.svg'"
                    src='${this.getTeamLogoSrc(teamId)}?a=${new Date().getTime()}'/>`,
                }}
            />
        );
    }
}

const TeamLogoBlank = props => {
    return <TeamLogo {...props} display="3d_jersey_back" />;
};
const TeamLogoEmpty = props => {
    return;
};

const options = ['logo', 'jersey', 'empty', 'transparent', 'short_name', '3d_jersey'];

export default withTheme(TeamLogo);
export { options, TeamLogoBlank, TeamLogo, TeamLogoEmpty };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/SMTeamLogo.js
 **/